"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersApi = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-members-v1-member/http");
var types_1 = require("@wix/ambassador-members-v1-member/types");
var http_2 = require("@wix/ambassador-members-v2-follow/http");
var BaseApi_1 = require("../BaseApi");
// https://bo.wix.com/wix-docs/rest/members/members
var MembersApi = /** @class */ (function (_super) {
    tslib_1.__extends(MembersApi, _super);
    function MembersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MembersApi.prototype.getMyMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var member;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.requestMyMember()];
                    case 1:
                        member = _a.sent();
                        return [2 /*return*/, member];
                }
            });
        });
    };
    MembersApi.prototype.queryMembersByIds = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryMembers({
                            query: {
                                filter: {
                                    id: {
                                        $in: ids,
                                    },
                                },
                            },
                            fieldSet: types_1.Set.FULL,
                        })];
                    case 1:
                        members = (_a.sent()).members;
                        return [2 /*return*/, members];
                }
            });
        });
    };
    MembersApi.prototype.queryMembers = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.queryMembers(payload))];
                    case 1:
                        data = ((_a.sent()) ||
                            {}).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    MembersApi.prototype.requestMyMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, member;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.getMyMember({ fieldSet: types_1.Set.FULL }))];
                    case 1:
                        member = ((_a.sent()) ||
                            {}).data.member;
                        return [2 /*return*/, member];
                }
            });
        });
    };
    MembersApi.prototype.followMember = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.followMember(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    MembersApi.prototype.unfollowMember = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.unfollowMember(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    MembersApi.prototype.listMyMemberFollowing = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.listMyMemberFollowing(payload || {}))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return MembersApi;
}(BaseApi_1.BaseApi));
exports.MembersApi = MembersApi;
//# sourceMappingURL=MembersApi.js.map